"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const recoil_1 = require("recoil");
const axios_1 = require("axios");
const api_1 = require("@/api");
const errors_1 = require("@/common/errors");
const fetchSettlementRequestData = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d;
    const { pathname } = window.location;
    const isCommission = pathname.includes('commission');
    const splitted = pathname.split('/');
    const roomId = isCommission ? splitted[2] : splitted.pop();
    const commissionOrderId = isCommission ? splitted.pop() : 0;
    const getUrl = `/api/v1/room/${roomId}/settlement-request${isCommission ? `/${commissionOrderId}` : ''}`;
    try {
        const response = yield (0, api_1.getData)(getUrl);
        if (response.status === 200)
            return response.data.result;
    }
    catch (error) {
        if (error instanceof axios_1.AxiosError) {
            const errorStatus = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status;
            const errorCode = (_d = (_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.meta) === null || _d === void 0 ? void 0 : _d.alert_type;
            if (errorCode === 40302) {
                return { id: 0 };
            }
            else if (errorStatus === 403)
                (0, errors_1.handle403Error)(error);
            else
                alert((0, errors_1.commonErrorMsg)(errorStatus));
        }
    }
});
exports.default = (0, recoil_1.atom)({
    key: 'settlementRequestDataState',
    default: fetchSettlementRequestData(),
});
